module.exports = __webpack_public_path__ + "static/media/Group 2250.10272212.svg";